<template>
	<div style="min-width: 1300px;">
		<layout>
			<div slot="body" style="padding: 30px 8%;overflow:hidden;" class="show-lst">
				<retrieval></retrieval>
				
			</div>
		</layout>

	</div>
</template>

<script>
	import layout from '@/view/layout/index.vue'
	import retrieval from './retrieval.vue'
	export default {
		name: 'metalcertificateindex',
		data:function(){
			return {};
		},
		created:function(){},
		components: {
			layout: layout,
			retrieval:retrieval
		},
		methods:{}
	}
</script>

<style >
	.show-lst .ivu-card-body{
		padding: 20px !important;
		color: #4D5669;
	}
	
	.show-lst .ivu-card-head p{
		color: #7070DD;
	}
</style>


// WEBPACK FOOTER //
// src/view/retrieval/index.vue